import { PageBlank } from '@/pages'
import { NotFound } from '@/shared'
import { createBrowserRouter } from 'react-router-dom'
import { AppLayout } from './AppLayout'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: '/',
        element: <PageBlank />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
])
